import { render } from "./wallet.vue?vue&type=template&id=f5471190&ts=true"
import script from "./wallet.vue?vue&type=script&lang=ts"
export * from "./wallet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__